import styled from 'styled-components';
// import { color } from 'styles/pallete';

export const container = styled.div<{ $isShow: boolean }>`
	width: 100%;
	height: 100%;
	overflow: auto;
	display: ${(props) => (props.$isShow ? 'flex' : 'none')};
	flex-direction: column;
	gap: 1.5rem;
	align-items: flex-start;
	justify-content: flex-start;
`;

export const centralize = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	align-items: center;
	justify-content: center;
`;

export const listFlags = styled.div`
	width: 99.6%;
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr;
	gap: 2.5rem;

	@media (max-width: 1000px) {
		grid-template-columns: 1fr;
	}
`;

export const flag = styled.div`
	display: flex;
	gap: 1rem;
	align-items: center;
	justify-content: flex-start;

	> p {
		font-size: 1.3rem;
		opacity: 0.8;
	}
`;
